/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type { IntlService } from "ember-intl";
import JournalEventBaseComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import InflammatoryEruptionDeclaredJournalEvent from "parog-web/models/inflammatory-eruption-declared-journal-event";

import styles from "./index.module.css";
export default class InflammatoryEruptionEditionFormComponent extends JournalEventBaseComponent {
  @service declare intl: IntlService;

  styles = styles;

  static forcDisplayName = "Déclarer des poussées inflammatoires";
  static fullComponentId = "inflammatory-eruption/edition-form";

  static journalEventClass = InflammatoryEruptionDeclaredJournalEvent;

  journalEventProperties = ["occurredAt", "nad", "nag", "duration", "details"];

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }
  //Overrwite to enable save button with 0 articulations selected
  get isDirty() {
    return true;
  }

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.occurredAt = new Date();
      model.nad = [];
      model.nag = [];
    }
    return model;
  }
}
